
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.5 0a9.5 9.5 0 110 19 9.5 9.5 0 010-19zm0 1a8.5 8.5 0 100 17 8.5 8.5 0 000-17zM9 14v-2h1v2H9zm0-4V5h1v5H9z","fill":"#000"}})])
          )
        }
      }
    